import React from 'react';
import {Button, Col, Divider, Empty, Form, Image, message, Radio, Row, Spin, Tag, Typography} from 'antd';
import {withRouter} from 'react-router';
import {CloseOutlined, ShoppingOutlined} from '@ant-design/icons'
import UPSTrackingStatusTimeline from '../../component/income/UPSTrackingStatusTimeline';
import {getArtistSaleReport, patchArtistSaleReports} from '../../api/artistSaleReports';
import {getArtworkInfoUrl, getPageId, sanity_s3_url_display} from '../../component/Utils';
import {getArtworkById} from '../../api/artworks';
import {colorArray, getFulfillmentStr} from '../../component/income/OrderTable';
import HttpError from '../../component/base/HttpError';

const {Title} = Typography

class OrderDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            orderId: getPageId(this.props),
            static_url: "",
            total: 0.0,
            order: {},
        }
        this.onVerifyClick = this.onVerifyClick.bind(this);
        this.onDeclineClick = this.onDeclineClick.bind(this);
    }

    componentDidMount() {
        this.setState({loading: true})
        Promise.resolve(getArtistSaleReport(this.state.orderId))
            .then((response) => {
                const order = response.data
                order.fullfillment_status = getFulfillmentStr(order.order_status)
                this.setState({
                    order: order,
                    total: Number(parseFloat(response.data.sku_price.replace(/,/g, '')) * parseFloat(
                        this.sanityQuantity(response.data.sku_quantity))).toLocaleString()
                })
                if (response.data?.sku_id > 0)
                    return getArtworkById(response.data.sku_id);
            })
            .then((response) => {
                if (response && response.data)
                    this.setState({
                        static_url: sanity_s3_url_display(response.data.static_url)
                    })
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            this.setState({
                loading: false
            })
        })
    }

    onXClick() {
        window.open("about:blank", "_self");
        window.close();
    }

    getOrderId = () => {
        let id = this.props.match.params.id
        if (!id) {
            const locationArry = this.props.location.pathname.split('/')
            if (locationArry.length > 0) {
                if (locationArry[locationArry.length - 1]) {
                    id = parseInt(locationArry[locationArry.length - 1])
                } else {
                    id = parseInt(locationArry[locationArry.length - 2])
                }
            }
        }
        return id
    }

    onVerifyClick() {
        if (this.isVerified(this.state.order.order_status)) {
            return;
        }
        this.setState({
            loading: true,
        }, () => {
            patchArtistSaleReports(this.getOrderId(), {order_status: 'order-confirmed'}).then(r => {
                window.location.reload()
                message.success('Successfully Verified Order').then((r) => {
                });
            }).catch((error) => {
                HttpError(error)
            }).finally(() => {
                this.setState({
                    loading: false,
                })
            })
        })
    }

    onDeclineClick() {
        if (this.isDeclined(this.state.order.order_status)) {
            return;
        }
        this.setState({
            loading: true,
        }, () => {
            patchArtistSaleReports(this.getOrderId(), {order_status: 'order-declined'}).then(r => {
                window.location.reload()
                message.success('Successfully Declined the Order').then((r) => {
                });
            }).catch((error) => {
                HttpError(error)
            }).finally(() => {
                this.setState({
                    loading: false,
                })
            })
        })
    }

    sanityQuantity(num_str) {
        if (!num_str) return 1
        if (num_str === 'test') return 1
        return num_str
    }

    getArtworkFullUrl = (element) => {
        return 'https://revart.co/artworks/info/' + getArtworkInfoUrl(element.id, element.name)
    }

    getFullfillStatus = (fulfillment_status) => {
        if (fulfillment_status === 'fulfilled') {
            return 'Fulfilled'
        } else if (fulfillment_status === 'canceled') {
            return 'Canceled'
        } else {
            return 'Unfulfilled'
        }
    }

    isVerified = (order_status) => {
        if (order_status !== 'none' && order_status !== 'buyer-paid' && order_status !== 'order-canceled' && order_status !== 'order-declined') {
            return true
        } else {
            return false
        }
    }

    isDeclined = (order_status) => {
        if (order_status === 'order-declined') {
            return true
        } else {
            return false
        }
    }

    onFulfillChange = (e) => {
        let order_status = 'order-confirmed'
        if (e.target.value === 'fulfilled') {
            order_status = 'fulfilled'
        } else if (e.target.value === 'canceled') {
            order_status = 'order-canceled'
        }

        this.setState({
            loading: true,
        }, () => {
            patchArtistSaleReports(this.getOrderId(), {order_status: order_status}).then(r => {
                message.success('Order Status Updated').then((r) => {
                    window.location.reload()
                });
            }).catch((error) => {
                HttpError(error)
            }).finally(() => {
                this.setState({
                    loading: false,
                })
            })
        })
    }

    render() {
        return (
            <Spin size='large' spinning={this.state.loading}>
                <Row gutter={[12, 12]}>
                    <Col span={22}>
                        <Title>
                            <ShoppingOutlined style={{marginRight: 8, marginBottom: 8}}/>
                            Order #{this.state.orderId}
                        </Title>
                    </Col>
                    <Col span={2}>
                        <Button type="text" onClick={this.onXClick}>
                            <CloseOutlined style={{color: 'gray'}}/>
                        </Button>
                    </Col>
                    <Col span={17}>
                        <Title level={4}>
                            Order Summary
                        </Title>
                    </Col>
                    <Col span={7}>
                        <Row justify="end" style={{marginRight: 12}}>
                            <Button size="medium" onClick={this.onVerifyClick} style={{
                                color: 'white',
                                backgroundColor: (!this.isVerified(this.state.order?.order_status) ? colorArray.verification["Unverified"] : colorArray.verification["Verified"])
                            }}>
                                {!this.isVerified(this.state.order?.order_status) ? "Verify the Order" : "Order Verified"}
                            </Button>
                            <Divider type={'vertical'} style={{height: '100%', width: '2px'}}/>
                            <Button size="medium" type={'ghost'} onClick={this.onDeclineClick} style={{
                                color: 'white',
                                backgroundColor: (!this.isDeclined(this.state.order?.order_status) ? colorArray.verification["Undeclined"] : colorArray.verification["Declined"])
                            }}>
                                {!this.isDeclined(this.state.order?.order_status) ? "Decline the Order" : "Order Declined"}
                            </Button>
                        </Row>
                    </Col>
                    <Col xs={8} sm={6} md={4} lg={3}>
                        <Image src={this.state.static_url}
                               preview={this.state.static_url}
                               style={{width: '80px', height: '80px', border: 'solid black'}}/>
                    </Col>
                    <Col xs={16} lg={8}>
                        <Row style={{paddingLeft: "1px"}}><h3><em>{this.state.order.sku_name}</em></h3></Row>
                        <Row style={{paddingLeft: "1px"}}>{this.state.order.sku_type}</Row>
                        <Row style={{paddingLeft: "1px"}}>Dimensions: </Row>
                        <Row style={{paddingLeft: "1px"}}><a target={'_blank'} rel={'noreferrer'}
                                                             href={this.getArtworkFullUrl({
                                                                 id: this.state.order.sku_id,
                                                                 name: this.state.order.sku_name
                                                             })}>SKU Number: {this.state.order.sku_id}</a></Row>
                    </Col>
                    <Col xs={8} lg={4}>
                        <Tag
                            color={colorArray.fulfillment[this.state.order.fulfillment_status]}>{this.getFullfillStatus(this.state.order.fulfillment_status)}</Tag>
                    </Col>
                    <Col xs={8} lg={3}>
                        ${Number(this.state.order.sku_price)?.toLocaleString() || ''}
                    </Col>
                    <Col xs={4} lg={2}>
                        x{this.sanityQuantity(this.state.order.sku_quantity) || 1}
                    </Col>
                    <Col xs={4} lg={3}>
                        <Row justify="end"><h3><em>${this.state.total}</em></h3></Row>
                    </Col>
                </Row>
                <Divider/>
                <Row style={{marginBottom: 16}}>
                    <Title level={4}>
                        Order Info
                    </Title>
                </Row>
                <Row style={{marginBottom: 16}}>
                    <Col span={6}>
                        Customer:
                    </Col>
                    <Col>
                        {this.state.order.buyer_name} ({this.state.order.buyer_email})
                    </Col>
                </Row>
                <Row style={{marginBottom: 16}}>
                    <Col span={6}>
                        Address:
                    </Col>
                    <Col>
                        {this.state.order.buyer_address}
                    </Col>
                </Row>
                <Row style={{marginBottom: 16}}>
                    <Col span={6}>
                        Shipping Address:
                    </Col>
                    <Col>
                        {this.state.order.buyer_address}
                    </Col>
                </Row>
                <Divider/>
                <Row style={{marginBottom: 16}}>
                    <Title level={4}>
                        Order Activity
                    </Title>
                    <Form.Item style={{marginLeft: 'auto', marginRight: 12}}
                               name="fulfillment_status" onChange={this.onFulfillChange}
                               rules={[{required: false, message: 'Please input fulfillment status!'}]}>
                        <Radio.Group name="fulfillment_status">
                            <Radio.Button value="fulfilled" style={{
                                background: (this.state.order.order_status === "fulfilled" ? colorArray.fulfillment["fulfilled"] : '#d9d9d9'),
                                color: 'white'
                            }}>Fulfilled</Radio.Button>
                            <Radio.Button value="none" style={{
                                background: ((this.state.order.order_status !== 'fulfilled' &&
                                    this.state.order.order_status !== "canceled") ? colorArray.fulfillment["none"] : '#d9d9d9'),
                                color: 'white'
                            }}>Unfulfilled</Radio.Button>
                            <Radio.Button value="canceled" style={{
                                background: (this.state.order.order_status === "canceled" ? colorArray.fulfillment["canceled"] : '#d9d9d9'),
                                color: 'white'
                            }}>Canceled</Radio.Button>
                        </Radio.Group>
                    </Form.Item>
                    {this.state.order?.ups_tracking_num && (
                        <UPSTrackingStatusTimeline num={this.state.order.ups_tracking_num}/>
                    )}
                    {!this.state.order?.ups_tracking_num && (
                        <Row style={{
                            width: '100%',
                            height: '100%',
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: 12
                        }}>
                            <Empty/>
                        </Row>
                    )}
                </Row>
            </Spin>
        )
    }
}

export default withRouter(OrderDetails)